import React from "react";
import "./styles.scss";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { StyledTableCell } from "../../../utils/styles";
import SortedTableItem from "../sortedTableItem";

function TableHeaderRow(props) {
  const {
    items,
    sortedIndexes = [],
    stickyFirstColumn = false,
    stickyLastColumn = false,
  } = props;

  const headerCell = (item, index) => {
    const sortedField = sortedIndexes.filter(
      (sortedIndex) => sortedIndex.index === index
    );
    const isFirstColumn = index === 0 && stickyFirstColumn;
    const isLastColumn = index === items.length - 1 && stickyLastColumn;
    const stickyClass = isFirstColumn
      ? "sticky-first-column"
      : isLastColumn
        ? "sticky-last-column"
        : "";

    return sortedField.length > 0 ? (
      <SortedTableItem
        key={`header-${index}`}
        orderKey={sortedField[0].orderKey}
        title={item}
        orderProps={sortedField[0].orderProps}
        className={stickyClass}
      />
    ) : (
      <StyledTableCell
        key={`header-${index}`}
        align={"center"}
        className={stickyClass}
      >
        {item}
      </StyledTableCell>
    );
  };

  return (
    <TableHead>
      <TableRow>{items.map((item, index) => headerCell(item, index))}</TableRow>
    </TableHead>
  );
}

export default TableHeaderRow;
